module.exports = __webpack_public_path__ + "static/media/po-undercarriage-5.27ed23ca.png";